import styles from "./payment-methods.module.scss";

export const ByMail = ({ paymentInfo, commonData, productName }) => (
  <>
    <div className={styles.headText}>
      Make your cheque or money order payable to:{" "}
      <span className={styles.highlightTxt}>‘{productName}’</span>. Attach your
      payment to the payment slip on your statement and return to:
    </div>
    <div className={styles.address}>
      <p>{productName}</p>
      <p>{paymentInfo.street}</p>
      <p>
        {paymentInfo.suburb} {paymentInfo.state} {paymentInfo.post_code}
      </p>
    </div>
    <p>
      Don&apos;t forget to write your name and account number on the back of
      your cheque or money order.
    </p>
    <div role="table" className={styles.table}>
      <div role="row" className={styles.row}>
        <div role="cell" className={styles.label}>
          Account number
        </div>
        <div role="cell">{commonData.accountNumber}</div>
      </div>
    </div>
    <p>Please allow up to 10 days to process your payment.</p>
  </>
);
